export const common = {
    en: {
        message: {
            game: 'Game',
            game_catalog: 'Games Library',
            custom_game: 'Custom game',
            create_custom_game: 'Create a custom game!',
            new_game: 'New game',
            start: 'Start',
            next: 'Next',
            roll: 'Roll',
            categories: 'Categories',
            sort: 'Sort',
            type_smth: 'Type something here...',
            nope: 'Nope!',
            yeah: 'Yeah!',
            sound: 'Sound',
            camera: 'Camera',
            cards: 'cards | cards | cards| cards',
            images: 'images | image | images| images',
            viewers: 'viewers | viewer | viewers| viewers',
            microphone: 'Microphone',
            on: 'on',
            off: 'off',
            on_fem: 'on',
            off_fem: 'off',
            reactions_menu_title: 'y/n - reaction buttons',
            camera_title: 'Camera settings',
            microphone_title: 'Microphone settings',
            chat_title: 'Show / hide chat panel',
            rules_title: 'Rules',
            dice_title: 'Dice',
            devices_settings: 'Devices settings',
            take_the_place: 'Take',
            symbol: 'Symbol',
            joined_the_room: 'joined the room',
            join_the_game: 'Join the game',
            stay_as_guest: 'Stay as a guest',
            join: 'Join',
            took_seat: 'took the',
            seat: 'seat',
            video: 'Video',
            image: 'Image',
            text: 'Text',
            download: 'Upload',
            cancel: 'Cancel',
            enter_text: 'Enter text',
            choose: 'Выбрать',
            youtube_link: 'Add a link to a Youtube video',
            image_url: 'or insert the URL of an image',
            drag_image: 'Drag image here',
            or: 'or',
            select_image: 'Select image from your computer',
            show_more: 'Show more',
            player: 'player',
            voted: 'voted',
            expired: 'is over!',
            round: 'Round',
            best: 'best',
            begins: 'begins',
            time_is_up: 'Time’s up',
            round_is_over: 'Round is over',
            game_has_ended: 'The game has ended',
            back_to_menu: 'Back to menu',
            buy_game: 'Buy game',
            publisher: 'Publisher',
            suggest: 'Suggest',
            suggested_to_play: 'would like to play',
            featured_games: 'Featured games',
            game_rules: 'Rules of the game',
            pack: 'packs | pack | packs',
            task: 'tasks | task | tasks',
            point: 'points | point | points',
            game_plural: 'games | game | games',
            hide_video: 'hide video',
            show_video: 'show video',
            interface_guide: 'Interface guide',
            run_timer: 'set timer',
            run_stopwatch: 'started stopwatch',
            on_time: 'on',
            time_range: 'from {from} to {to}',
            more_players: 'more players | more player | more players | more players',
            incorrect_working: 'The game may work with issues',
            need_more_players: 'To play {name} you have to invite',
            video_stub_title: 'Welcome to&nbsp;Festa!<br> \n' +
                'The only platform for online party games',
            video_stub_text: '<p>Festa is&nbsp;still in&nbsp;Beta.</p>\n' +
                '<p>Soon you will be&nbsp;able to&nbsp;play it&nbsp;on&nbsp;any device. ' +
                'But for now it&rsquo;s best optimized for desktop with the Chrome browser. ' +
                'We&nbsp;recommend using headphones in&nbsp;case of&nbsp;issues with echo.</p>\n' +
                '<p>Contact&nbsp;us for any issues via <a href="mailto:info@festa.games">info@festa.games</a></p>',
            report_problem: 'Report a problem',
            type_problem: 'Type of problem ',
            describe_problem: 'Please, describe your problem',
            fill_name: 'Fill in your name',
            email: 'Email',
            thank_you: 'Thank You!',
            connection_problem: 'Video chat connection',
            camera_issues: 'Camera issues',
            sound_issues: 'Sound issues',
            game_problems: 'Game problems (scoring, timers, e.t.c)',
            other_problems: 'other',
            task_is_hidden: 'Task is hidden',
            choose_game: 'Festa Party',
            choose_pack: 'Choose a setup',
            choose_with_title: 'Choose',
            invite: 'Invite',
            help: 'Need help?',
            next_player: 'Next player',
            all: 'All',
            nobody: 'Nobody',
            message_is_invisible: 'The message is invisible for you',
            anonymously: 'Anonymously',
            table: 'Table',
            search: 'Search',
            choose_color: 'Choose color',
            close: 'Close',
            lock_the_room: 'Lock the room',
            change_url: 'Change room URL',
            time_played: 'Time played',
            room_lifetime: "Room's time left",
            welcome_title: 'Play your favorite party games with friends!',
            welcome_text: 'Festa is&nbsp;in&nbsp;beta. We&nbsp;recommend using a&nbsp;desktop and the Chrome browser. Use headphones to&nbsp;avoid any echo.\n' +
                'If&nbsp;you have any questions, trouble, or&nbsp;recommendations please write to&nbsp;us at&nbsp;<a href="mailto:info@festa.games">info@festa.games</a>',
            see_all: 'See all',
            add_as_stack: 'Components with the same dimensions can be added as one stack',
            add_card_shirt: 'Add the back side image if you have it',
            uploaded: 'Uploaded',
            isStack: 'Upload as a stack',
            of: 'of',
            no_results: 'No results',
            player_restart_game: 'has restarted the game',
            join_next_round: 'You’ll join at the start of the next round',
            join_next_game: 'You’ll join at the start of the next game',
            use_text_chat: 'While you’re waiting you can still use the text chat',
            settings: 'Settings',
            settings_user: 'User',
            settings_room: 'Room',
            freeze_the_room: 'Freeze the room',
            start_the_room: 'Start the room',
            code_time_remaining: 'Code time remaining',
            save:'Save',
            change_the_url: 'Change the URL',
            comment: 'Comment',
            settings_comment: 'For example, the name of the game or next meeting time',
            success_report_problem: 'Your message was sent',
            success_report_problem_text: 'We will solve the problem as soon as possible',
            enter_room_code: 'Enter the room code to unlock settings',
            link_copied: 'The link copied',
            aria_label_settings: 'Enter room code to unblock settings',
            video_is_coming: 'Video is coming soon',
            game_paused: 'Game is paused',
            message_continue_game: 'The game will be continued for all players',
            is_now: 'is now',
            wrong_browser: 'We recommend using the Chrome browser, otherwise Festa may be unstable.',
            left_room: 'left the room',
            game_finished: 'Game is finished!',
            play_again: 'Play again or try something else',
            dont_miss_new_games: 'Like Festa? Don’t miss our new games!'
        }
    },
    ru: {
        message: {
            game: 'Игра',
            game_catalog: 'Игровой каталог',
            custom_game: 'Своя игра',
            create_custom_game: 'Создать свою игру!',
            new_game: 'Новая игра',
            start: 'Начать',
            roll: 'Бросок',
            type_smth: 'Напишите что-нибудь...',
            nope: 'Бзззз!',
            yeah: 'Дзынь!',
            sound: 'Звук',
            camera: 'Камера',
            microphone: 'Микрофон',
            on: 'включен',
            categories: 'Категории',
            sort: 'Сортировка',
            off: 'выключен',
            on_fem: 'включена',
            off_fem: 'выключена',
            reactions_menu_title: 'y/n - reaction buttons',
            camera_title: 'Camera settings',
            microphone_title: 'Microphone settings',
            chat_title: 'Show / hide chat panel',
            rules_title: 'Правила',
            dice_title: 'Dice',
            suggest: 'Предложить',
            suggested_to_play: 'предлагает сыграть в',
            choose_color: 'Выберите цвет',
            devices_settings: 'Настройка устройств',
            need_more_players: 'Для игры {name} требуется еще',
            help: 'Нужна помощь?',
            take_the_place: 'Занять',
            symbol: 'Символ',
            joined_the_room: 'присоединился к игре',
            join_the_game: 'Войти в игру',
            stay_as_guest: 'Остаться гостем',
            join: 'Присоединиться',
            took_seat: 'теперь',
            cards: 'карт | карта | карты | карт',
            images: 'изображений | изображение | изображения| изображений',
            viewers: 'зрителей | зритель | зрителя | зрителей',
            game_plural: 'игр | игра | игры | игр',
            seat: '',
            video: 'Видео',
            image: 'Изображение',
            text: 'Текст',
            download: 'Добавить',
            cancel: 'Отмена',
            enter_text: 'Введите текст',
            choose: 'Выбрать',
            choose_pack: 'Выберите сетап',
            choose_with_title: 'Выберите',
            youtube_link: 'Ссылка на youtube-видео',
            image_url: 'или укажите URL картинки',
            drag_image: 'Перетащите картинку в окно',
            or: 'или',
            select_image: 'Выберите файл с комьютера',
            show_more: 'Показать ещё',
            player: 'игрок',
            voted: 'проголосовал',
            expired: 'истекло!',
            round: 'Раунд',
            begins: 'начинается',
            time_is_up: 'Время истекло',
            round_is_over: 'Конец раунда',
            game_has_ended: 'Игра окончена',
            buy_game: 'Купить игру',
            publisher: 'Издатель',
            featured_games: 'Избранные игры',
            game_rules: 'Правила игры',
            pack: 'паков | пак | пака | паков',
            task: 'заданий | задание | задания | заданий',
            point: 'очков | очко | очка | очков',
            hide_video: 'скрыть видео',
            show_video: 'показать видео',
            interface_guide: 'Справка по интерфейсу',
            run_timer: 'запустил таймер',
            run_stopwatch: 'запустил секундомер',
            on_time: 'на',
            best: 'рек.',
            need: 'нужно | нужен | нужно | нужно',
            time_range: 'от {from} до {to}',
            more_players: 'человек | человек | человека | человек',
            incorrect_working: 'Сейчас работа может быть некорректной',
            need_more_pincorrectlayers: 'Для игры {name} вам {need} еще',
            video_stub_title: 'Добро пожаловать на&nbsp;Festa!<br>\n' +
                'Играйте в&nbsp;любимые пати игры \n' +
                'со&nbsp;всего мира вместе с&nbsp;друзьями!',
            video_stub_text: '<p>Festa в&nbsp;Альфа версии.</p> \n' +
                '<p>Скоро удобно будет играть не&nbsp;только на&nbsp;десктопе, но&nbsp;и&nbsp;на&nbsp;смартфоне или планшете.' +
                'А&nbsp;пока мы&nbsp;рекомендуем использовать версию для&nbsp;ПК, браузер Chrome и&nbsp;наушники, если появится эхо</p>\n' +
                '<p>По&nbsp;вопросам, проблемам и&nbsp;предложениям пишите&nbsp;на&nbsp;<a href="mailto:info@festa.games">info@festa.games</a></p>',
            report_problem: 'Сообщить о проблеме',
            type_problem: 'Тип проблемы',
            describe_problem: 'Пожалуйста, опишите вашу проблему',
            fill_name: 'Ваше имя',
            email: 'Email',
            thank_you: 'Спасибо!',
            connection_problem: 'Проблемы с подключением',
            camera_issues: 'Камера',
            sound_issues: 'Микрофон и звуки',
            game_problems: 'Игровой процесс',
            other_problems: 'Другое',
            task_is_hidden: 'Задание скрыто',
            choose_game: 'Выберите игру',
            invite: 'Пригласить',
            next_player: 'Следующий игрок',
            all: 'Все',
            nobody: 'Никто',
            message_is_invisible: 'Сообщение скрыто для вас',
            anonymously: 'Анонимно',
            table: 'Стол',
            search: 'Поиск',
            close: 'Закрыть',
            lock_the_room: 'Заморозить комнату',
            change_url: 'Сменить URL',
            time_played: 'Время кода',
            room_lifetime: 'Срок жизни комнаты',
            welcome_title: 'Играй в любимые пати игры с друзьями!',
            welcome_text: 'Мы&nbsp;рекомендуем использовать версию для&nbsp;ПК, браузер Chrome и&nbsp;наушники, если появится эхо.\n' +
                'По&nbsp;вопросам, проблемам и&nbsp;предложениям пишите на&nbsp;<a href="mailto:info@festa.games">info@festa.games</a>',
            see_all: 'Смотреть все',
            add_as_stack: 'Объекты одинакового размера можно добавить стопкой',
            add_card_shirt: 'Загрузите рубашку, или будет установлена стандартная',
            uploaded: 'Загружено',
            isStack: 'Загрузить стопкой',
            of: 'из',
            no_results: 'Не найдено',
            player_restart_game: 'запустил игру заново',
            join_next_round: 'Вы присоединитесь в следующем раунде',
            join_next_game: 'Вы присоединитесь в следующей игре',
            use_text_chat: 'Во время ожидания вы можете общаться через чат',
            settings: 'Настройки',
            settings_user: 'Пользователь',
            settings_room: 'Комната',
            freeze_the_room: 'Заморозить комнату',
            start_the_room: 'Разморзить комнату',
            code_time_remaining: 'Оставшееся время кода',
            save: 'Сохранить',
            change_the_url: 'Сменить URL комнаты',
            comment: 'Комментарий',
            settings_comment: 'Например, название игры или время следующей встречи.',
            success_report_problem: 'Ваше сообщение было отправлено',
            success_report_problem_text: 'Мы постаремся решить эту проблему как можно скорее',
            enter_room_code: 'Введите код комнаты, чтобы разблокировать настройки',
            link_copied: 'Ссылка скопирована',
            aria_label_settings: 'Введите код комнаты, чтобы разблокировать настройки\n',
            video_is_coming: 'Видео скоро будет',
            game_paused: 'Игра приостановлена',
            message_continue_game: 'Игра будет продолжена для всех игроков',
            is_now: 'стал',
            wrong_browser: 'Мы рекомендуем использовать бразуер Chrome, иначе Festa может работать нестабильно.',
            left_room: 'покинул комнату',
            game_finished: 'Игра окончена!',
            play_again: 'Сыграйте снова',
            dont_miss_new_games: 'Нравится Festa? Не пропусти новые игры!'
        },
    }
};
